import { TextInput } from "components/core";
import { useFormik } from "formik";
import { FC } from "react";
import { wrapClick } from "utils";
import moment from "moment";
import {
  IResolveFATServiceOrderFormSchema,
  TestInfoFormSchema,
} from "./schema";
import lodash from "lodash";

export interface ContractInfoFormProps {
  handleNext: (values: IResolveFATServiceOrderFormSchema["testInfo"]) => void;
  handlePrevious: () => void;
  initialValues: IResolveFATServiceOrderFormSchema["testInfo"];
  values: IResolveFATServiceOrderFormSchema;
  handleCancel: () => void;
  meterContractor: any;
}

const TestInfoForm: FC<ContractInfoFormProps> = ({
  initialValues,
  handleNext,
  handleCancel,
  meterContractor,
}) => {

  const form = useFormik({
    initialValues,
    validationSchema: TestInfoFormSchema,
    onSubmit: (values) => {
      handleNext({
        ...values,
        fatDate: values.fatStartDate,
        numberOfECGReps: values.representatives?.length
      });
    },
    onReset: () => {
      handleCancel?.();
    },
  });

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <div className="space-y-6 divide-y divide-gray-200 p-6 flex-1 overflow-y-auto">
        <div>
          <span className="text-xs font-light">Main Test Information</span>
          <div className="grid grid-cols-2 gap-6 mt-2">
            <div className="col-span-2">
              <TextInput
                id="projectName"
                label="Project Name"
                type="text"
                placeholder="e.g. Factory Acceptance Test 2025"
                {...form}
              />
            </div>

            <div className="">
              <TextInput
                id="numberOfSupplierReps"
                label="No. Of Supplier Representatives"
                type="number"
                min={0}
                step={1}
                placeholder="e.g. 3"
                {...form}
              />
            </div>
            <div className="">
              <TextInput
                id="areaOfDeployment"
                label="Area Of Deployment"
                type="text"
                placeholder="e.g. Tema East"
                {...form}
              />
            </div>
            <div className="">
              <TextInput
                id="address"
                label="Facility Address"
                type="text"
                placeholder="e.g. Tema Test Facility"
                {...form}
              />
            </div>
            <div className="">
              <TextInput
                id="ghanaPostAddress"
                label="GhanaPost Address"
                type="text"
                placeholder="e.g. GA-123-1234"
                {...form}
              />
            </div>
          </div>
        </div>

        <div className="pt-6">
          <span className="text-xs font-light">Timeline Information</span>
          <div className="grid grid-cols-2 gap-6 mt-2">
            <div className="">
              <TextInput
                id="fatStartDate"
                label="FAT Start Date"
                type="date"
                max={moment().format("YYYY-MM-DD")}
                min={moment().subtract(12, "months").format("YYYY-MM-DD")}
                placeholder="e.g. 06/03/1957"
                {...form}
              />
            </div>
            <div className="">
              <TextInput
                id="fatToDate"
                label="FAT End Date"
                type="date"
                min={moment(form.values.fatStartDate).format("YYYY-MM-DD")}
                max={moment().format("YYYY-MM-DD")}
                placeholder="e.g. 06/03/1957"
                {...form}
              />
            </div>
          </div>
        </div>
        <div className="pt-6">
          <span className="text-xs font-light">ECG Representatives Information</span>
          <div className={"flex flex-col"}>
            {
              lodash.times(
                form.values.representatives?.length + 1,
                (idx) => (
                  <div className={"border-b last:border-0 border-gray-300 py-4 first:pt-3"} key={idx}>
                    <span className="text-xs font-light">Representative #{idx + 1} Information</span>
                    <div className='grid grid-cols-2 gap-6 mt-2'>
                      <div className="">
                        <TextInput
                          id={`representatives.${idx}.fullName`}
                          label="Representative Name"
                          type="text"
                          placeholder='eg. Kwame Mensah'
                          required={true}
                          {...form}
                        />
                      </div>
                      <div className="">
                        <TextInput
                          id={`representatives.${idx}.designation`}
                          label="Designation"
                          type="text"
                          placeholder='eg. Site Manager'
                          required={true}
                          {...form}
                        />
                      </div>
                      <div className="">
                        <TextInput
                          id={`representatives.${idx}.phoneNumber`}
                          label="Phone Number"
                          type="text"
                          placeholder='eg. 0201234567'
                          required={true}
                          {...form}
                        />
                      </div>
                    </div>
                  </div>
                ))
            }
          </div>
        </div>
      </div>
      <div className="bg-gray-50 dark:bg-gray-800 px-4 py-3 sm:py-4 sm:px-6 sm:flex sm:flex-row-reverse border-t border-gray-200">
        <button
          type="button"
          data-invalid={!form.isValid}
          onClick={wrapClick(form.handleSubmit)}
          className="w-full inline-flex justify-center data-invalid:bg-gray-200 data-invalid:border-gray-400 data-invalid:cursor-not-allowed data-invalid:text-gray-600 rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
        >
          Next
        </button>
        <button
          type="button"
          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-4 py-2 bg-white dark:bg-gray-900 text-base font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 hover:dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={wrapClick(form.resetForm)}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default TestInfoForm;
